export interface ComparisonRow {
  feature: string
  /** Valores por columna: la primera clave es el header (competidor),
   *  la última suele ser "Voltary" */
  [key: string]: string
}

interface ComparisonTableProps {
  /** Primera columna: nombre de la feature. Resto: competidores */
  competitors: string[]
  rows: ComparisonRow[]
}

/**
 * Tabla comparativa responsive. En móvil las celdas se apilan
 * mostrando el nombre del competidor en cada valor.
 */
export function ComparisonTable({ competitors, rows }: ComparisonTableProps) {
  return (
    <div className="marketing-table-wrap">
      <table className="marketing-table">
        <thead>
          <tr>
            <th>Característica</th>
            {competitors.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.feature}>
              <th scope="row">{row.feature}</th>
              {competitors.map((c) => (
                <td key={c} data-label={c}>
                  {row[c]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
